var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { jsx as _jsx } from "react/jsx-runtime";
// SPDX-FileCopyrightText: 2025 Sequent Tech Inc <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import React from "react";
import { useAppSelector } from "../../store/hooks";
import { showDemo, } from "../../store/ballotStyles/ballotStylesSlice";
import { styled } from "@mui/material/styles";
import { Box } from "@mui/material";
import { useParams } from "react-router-dom";
var Background = styled(Box)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    position: absolute;\n    width: 100%;\n    height: 100%;\n    overflow: hidden;\n    z-index: -1;\n    &::before {\n        content: \"\";\n        position: absolute;\n        top: 0;\n        left: 0;\n        width: 100%;\n        height: 100%;\n        background-image: ", ";\n        background-repeat: repeat;\n        background-position: center;\n        background-size: 100px 100px;\n        opacity: 0.3;\n    }\n"], ["\n    position: absolute;\n    width: 100%;\n    height: 100%;\n    overflow: hidden;\n    z-index: -1;\n    &::before {\n        content: \"\";\n        position: absolute;\n        top: 0;\n        left: 0;\n        width: 100%;\n        height: 100%;\n        background-image: ", ";\n        background-repeat: repeat;\n        background-position: center;\n        background-size: 100px 100px;\n        opacity: 0.3;\n    }\n"])), function (_a) {
    var imageUrl = _a.imageUrl;
    return (imageUrl ? "url(".concat(imageUrl, ")") : "none");
});
var DEMO_URL_PATH = "/demo-banner.png";
var WatermarkBackground = function () {
    var electionId = useParams().electionId;
    var isDemo = useAppSelector(showDemo(electionId));
    return isDemo ? _jsx(Background, { imageUrl: DEMO_URL_PATH, className: "watermark-background" }) : null;
};
export default WatermarkBackground;
var templateObject_1;
